module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/orange.png?1aeb9bfc";